export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-black text-foreground-900 text-center mb-10">
          关于青柠影视
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-background-100 rounded-xl p-6 md:p-7 text-center border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-primary-100">
              <i className="ri-eye-line text-primary-500 text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">高清流畅</h3>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              全站 1080P 超清画质，智能 CDN 加速，拒绝缓冲卡顿，给你丝滑追剧体验
            </p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-7 text-center border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-accent-100">
              <i className="ri-global-line text-accent-500 text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">海量资源</h3>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              20000+ 影视资源库，涵盖电视剧、电影、综艺、动漫全品类，每日同步更新
            </p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 md:p-7 text-center border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-secondary-100">
              <i className="ri-shield-check-line text-secondary-500 text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">永久免费</h3>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              无需付费、无需注册、无需下载，打开即看，让每个人都有平等享受影视的权利
            </p>
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-foreground-600 mt-8 leading-relaxed max-w-2xl mx-auto">
          青柠影视成立于 2023 年，始终秉持"让好内容触手可及"的理念。团队汇聚了热爱影视的技术人和内容编辑，每天精心筛选优质资源，确保片库新鲜、画质在线、播放流畅。无论你是追剧达人还是电影爱好者，青柠影视都是你值得信赖的免费追剧看片平台。
        </p>
      </div>
    </section>
  );
}